























import { Component, Vue } from 'vue-property-decorator';
import EditPermission from '../../components/editPermission.vue';
import EditTeams from '../../components/editTeams.vue';
import EditRoles from '../../components/editRoles.vue';
import { userManage } from '../user';

@Component({
  components: {
    EditPermission,
    EditRoles,
    EditTeams,
  },
})
export default class UserModal extends Vue {
  private componentName = 'edit-permissions';
  private type = 'add';
  private visible = false;
  private title = this.$t('user.updatePermission').toString();
  private permissions: IPermission.IResponse.IPermissionInfo[] = [];
  private roles: IRole.IResponse.IRoleInfo[] = [];
  private teams: ITeam.IResponse.ITeamInfo[] = [];
  public showModal(component: 'edit-permissions' | 'edit-roles' | 'edit-teams' , type: 'add' | 'del' = 'add') {
    this.visible = true;
    this.componentName = component;
    if (component === 'edit-permissions') {
      this.permissions = userManage.editData.userInfo?.permissions || [];
      this.title = this.$t('user.updatePermission').toString();
    }
    if (component === 'edit-roles') {
      this.roles = userManage.editData.userInfo?.roles || [];
      this.title = this.$t('user.updateRole').toString();
    }
    if (component === 'edit-teams') {
      this.teams = userManage.editData.userInfo?.teams || [];
      this.title = this.$t('user.updateTeam').toString();
    }
    this.componentName = component;
    this.type = type;
  }
  public addPermissions(permissionIds: string[]): Promise<string> {
    return userManage.requestAddPermissions(permissionIds);
  }
  public delPermissions(permissionIds: string[]): Promise<string> {
    return userManage.requestDeletePermissions(permissionIds);
  }
  public addRoles(roleIds: string[]): Promise<string> {
    return userManage.requestAddRoles(roleIds);
  }
  public delRoles(roleIds: string[]): Promise<string> {
    return userManage.requestDeleteRoles(roleIds);
  }
  public addTeams(teamIds: string[]): Promise<string> {
    return userManage.requestAddTeams(teamIds);
  }
  public delTeams(teamIds: string[]): Promise<string> {
    return userManage.requestDeleteTeams(teamIds);
  }
}
